// extracted by mini-css-extract-plugin
export default {"btns__list":"MassBtns_btns__list__XrQTE","btns__item":"MassBtns_btns__item__4hKF8"};